import type {
  Form,
  FormCreateRequest,
  FormFieldInput,
  FormFieldList,
  FormList,
  FormPatchRequest,
} from '@shared/types/form';
import { api } from './client';

export function listForms(): Promise<FormList> {
  return api.get<FormList>('/api/forms');
}

export function getForm(id: string): Promise<Form> {
  return api.get<Form>(`/api/forms/${encodeURIComponent(id)}`);
}

export function listFormFields(id: string): Promise<FormFieldList> {
  return api.get<FormFieldList>(`/api/forms/${encodeURIComponent(id)}/fields`);
}

export function createForm(body: FormCreateRequest): Promise<Form> {
  return api.post<Form>('/api/forms', body);
}

export function patchForm(id: string, body: FormPatchRequest): Promise<Form> {
  return api.patch<Form>(`/api/forms/${encodeURIComponent(id)}`, body);
}

export function replaceFormFields(
  id: string,
  body: FormFieldInput[],
): Promise<FormFieldList> {
  return api.put<FormFieldList>(`/api/forms/${encodeURIComponent(id)}/fields`, body);
}
